module.exports = __webpack_public_path__ + "static/media/A Distant Shore.7ec02c05.jpg";